import React from 'react';
import './TexturePattern.scss';

const TexturePattern = ({ isFooter }) => {
    // If it's a footer, only show dot patterns
    if (isFooter) {
        return (
            <div className="texture-container footer-texture">
                <div className="dot-pattern top-left"></div>
                <div className="dot-pattern top-right"></div>
                <div className="dot-pattern bottom-left"></div>
                <div className="dot-pattern bottom-right"></div>
            </div>
        );
    }
    
    // For other sections, keep all patterns
    return (
        <div className="texture-container">
            <div className="dot-pattern top-left"></div>
            <div className="dot-pattern bottom-right"></div>
            <div className="line-pattern top-right"></div>
            <div className="line-pattern bottom-left"></div>
            <div className="circle-pattern medium"></div>
            <div className="circle-pattern large"></div>
            <div className="cross-pattern top"></div>
            <div className="cross-pattern bottom"></div>
        </div>
    );
};

export default TexturePattern; 